import { render, staticRenderFns } from "./dict-vertical.vue?vue&type=template&id=26d4c19d&"
import script from "./dict-vertical.vue?vue&type=script&lang=js&"
export * from "./dict-vertical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports